var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5470_30028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.5078 75.8407H13.616C10.4408 75.8407 7.86679 73.2667 7.86679 70.0915V29.4431C7.86679 26.2679 10.4408 23.6938 13.616 23.6938H80.5078C83.683 23.6938 86.257 26.2679 86.257 29.4431V70.0917C86.2568 73.2667 83.683 75.8407 80.5078 75.8407Z",
    fill: "url(#paint0_linear_5470_30028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5078 75.8407H13.616C10.4408 75.8407 7.86679 73.2667 7.86679 70.0915V29.4431C7.86679 26.2679 10.4408 23.6938 13.616 23.6938H80.5078C83.683 23.6938 86.257 26.2679 86.257 29.4431V70.0917C86.2568 73.2667 83.683 75.8407 80.5078 75.8407Z",
    fill: "url(#paint1_linear_5470_30028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5078 75.8407H13.616C10.4408 75.8407 7.86679 73.2667 7.86679 70.0915V29.4431C7.86679 26.2679 10.4408 23.6938 13.616 23.6938H80.5078C83.683 23.6938 86.257 26.2679 86.257 29.4431V70.0917C86.2568 73.2667 83.683 75.8407 80.5078 75.8407Z",
    fill: "url(#paint2_linear_5470_30028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 17.9969V82.9639C100 84.6791 98.6094 86.0697 96.8942 86.0697H41.8955C40.1803 86.0697 38.7897 84.6793 38.7897 82.9639V3.10586C38.7897 1.39063 40.1803 0 41.8955 0H82.0031C83.6754 0 85.1114 0.664258 86.2938 1.84688L98.1532 13.7063C99.3358 14.8887 100 16.3244 100 17.9969Z",
    fill: "url(#paint3_linear_5470_30028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2937 1.84687C85.1113 0.664258 83.6756 0 82.0031 0H47.5076L45.7111 1.79648V11.2021L100 65.4908V17.9969C100 16.3246 99.3357 14.8887 98.1531 13.7062L86.2937 1.84687Z",
    fill: "url(#paint4_linear_5470_30028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2938 1.84688C85.1113 0.664258 83.6756 0 82.0031 0H65.2344V86.0697H96.8941C98.6094 86.0697 100 84.6793 100 82.9639V17.9969C100 16.3246 99.3357 14.8887 98.1531 13.7063L86.2938 1.84688Z",
    fill: "url(#paint5_linear_5470_30028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 27.5114L79.4754 6.98657L58.9222 29.5073L100 70.585V27.5114Z",
    fill: "url(#paint6_linear_5470_30028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 29.6145V17.9969C100 16.8229 99.6715 15.766 99.0674 14.8311H85.2166L100 29.6145Z",
    fill: "url(#paint7_linear_5470_30028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3586 15.3844H86.5828C85.4959 15.3844 84.6148 14.5033 84.6148 13.4164V3.64082C84.6148 1.63008 82.9849 0 80.974 0H83.1068C83.5849 -1.51883e-06 84.0584 0.0941739 84.5001 0.277149C84.9418 0.460124 85.3432 0.728314 85.6812 1.06641L98.933 14.3182C99.2711 14.6562 99.5393 15.0576 99.7222 15.4993C99.9052 15.941 99.9994 16.4145 99.9994 16.8926V20.0311V19.0252C99.9994 17.0145 98.3693 15.3844 96.3586 15.3844Z",
    fill: "url(#paint8_linear_5470_30028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7897 60.1226V82.9638C38.7897 84.679 40.1803 86.0696 41.8955 86.0696H96.8942C98.6094 86.0696 100 84.6792 100 82.9638V60.1226H38.7897Z",
    fill: "url(#paint9_linear_5470_30028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1111 49.7673V86.0697H96.8942C98.6094 86.0697 100 84.679 100 82.9638V71.6562L78.1111 49.7673Z",
    fill: "url(#paint10_linear_5470_30028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.573 21.494C83.5316 26.2772 80.0141 31.5187 74.8455 31.5187H73.8496C73.0287 31.5187 72.2215 31.7479 71.4668 32.1136C70.9795 32.3499 70.5133 32.6427 70.0793 32.9673C69.8814 33.1146 69.6412 33.1939 69.3945 33.1935C69.1473 33.1935 68.9062 33.1144 68.7084 32.9661C67.6023 32.1388 66.2904 31.5187 64.9398 31.5187H63.9439C58.7754 31.5187 55.2578 26.2772 57.2158 21.494L58.4969 18.3657C58.9364 17.2922 59.0276 16.1078 58.7576 14.9796C58.4876 13.8515 57.8701 12.8366 56.9922 12.0784C56.7735 11.8897 56.6328 11.6264 56.5972 11.3398C56.5617 11.0531 56.6339 10.7635 56.7998 10.5271L59.1568 7.16631C59.3091 6.9492 59.5309 6.79052 59.7855 6.71645C60.0402 6.64237 60.3124 6.65734 60.5574 6.75889C62.6546 7.62875 64.9602 7.86663 67.1908 7.44326C67.5385 7.37699 67.8683 7.23788 68.1584 7.03506C68.449 6.83232 68.6945 6.57173 68.8797 6.26963C68.9978 6.07764 69.1961 5.98193 69.3943 5.98193C69.5926 5.98193 69.7914 6.07764 69.9096 6.26963C70.2838 6.87959 70.8951 7.30967 71.5984 7.44326C72.3144 7.57916 73.0416 7.6475 73.7703 7.64736C75.3013 7.64749 76.8172 7.34557 78.2312 6.75889C78.4763 6.65732 78.7486 6.64232 79.0034 6.71635C79.2581 6.79038 79.48 6.94902 79.6324 7.16611L81.9895 10.5269C82.1272 10.7226 82.201 10.9562 82.2008 11.1956C82.201 11.3631 82.165 11.5287 82.0953 11.6811C82.0256 11.8334 81.9238 11.9689 81.7969 12.0782C80.9189 12.8364 80.3013 13.8512 80.0313 14.9794C79.7613 16.1076 79.8526 17.292 80.2922 18.3655L81.573 21.494Z",
    fill: "url(#paint11_linear_5470_30028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4328 31.5066C69.4216 31.5144 69.4083 31.5186 69.3946 31.5186C69.381 31.5186 69.3676 31.5144 69.3564 31.5066C67.9043 30.491 66.3836 29.956 64.9398 29.956H64.118C61.6996 29.956 59.4635 28.5201 58.5973 26.2621C58.0854 24.9279 58.0992 23.4603 58.6619 22.0859L59.943 18.9578C60.2933 18.1049 60.4733 17.1916 60.4727 16.2695C60.4733 14.5334 59.8374 12.8572 58.6854 11.5584C58.4541 11.2976 58.4408 10.9086 58.641 10.6232L59.9205 8.79918C60.015 8.66421 60.1508 8.56354 60.3074 8.51226C60.464 8.46099 60.633 8.46188 60.7891 8.51481C62.1515 8.97685 63.5805 9.21182 65.0191 9.21031C65.8438 9.21031 66.6725 9.13238 67.4826 8.97848C68.0471 8.87186 68.5824 8.64621 69.0529 8.31656C69.1565 8.24436 69.2568 8.16746 69.3533 8.0861C69.3651 8.07607 69.38 8.07056 69.3955 8.07056C69.411 8.07056 69.4259 8.07607 69.4377 8.0861C69.9739 8.53898 70.6177 8.84623 71.307 8.97828C72.1192 9.13236 72.944 9.20992 73.7707 9.20992C75.2093 9.21144 76.6384 8.97654 78.0008 8.51461C78.1568 8.46175 78.3258 8.46089 78.4824 8.51216C78.639 8.56343 78.7748 8.66406 78.8693 8.79899L80.1488 10.623C80.3551 10.917 80.3232 11.3097 80.0859 11.5791C79.212 12.5712 78.6329 13.7879 78.414 15.0917C78.1951 16.3956 78.3451 17.7347 78.8471 18.9578L80.1275 22.0859C80.6904 23.4603 80.7045 24.9277 80.1928 26.2619C79.3268 28.5199 77.0906 29.956 74.6721 29.956H73.85C72.8463 29.956 71.8156 30.2087 70.7863 30.7072C70.3147 30.9374 69.8621 31.2048 69.4328 31.5066Z",
    fill: "url(#paint12_linear_5470_30028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9441 31.5188H64.94C66.2904 31.5188 67.6025 32.1389 68.7086 32.9663C68.9068 33.1141 69.1475 33.1939 69.3947 33.1936C69.6414 33.1941 69.8816 33.1147 70.0795 32.9674C70.5135 32.6428 70.9797 32.35 71.467 32.1137C72.2217 31.7483 73.0289 31.5188 73.8498 31.5188H74.8457C79.6543 31.5188 83.033 26.9821 81.9031 22.4983H56.8863C55.7568 26.9819 59.1355 31.5188 63.9441 31.5188Z",
    fill: "url(#paint13_linear_5470_30028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8762 29.3754C69.7305 29.4617 69.5644 29.5072 69.3952 29.5074C69.2259 29.5075 69.0598 29.4621 68.914 29.376C67.7902 28.7122 66.6324 28.3651 65.5211 28.3651H64.7369C62.9293 28.3651 61.2523 27.3682 60.4396 25.7536C59.831 24.5442 59.7758 23.162 60.3014 21.878L61.4152 19.1577C61.7327 18.3849 61.8957 17.5574 61.8951 16.7219C61.8951 15.2688 61.4054 13.8741 60.5238 12.7506C60.2672 12.4237 60.249 11.9696 60.4877 11.6293L61.1396 10.6999C61.2533 10.5372 61.4155 10.4146 61.603 10.3496C61.7905 10.2846 61.9938 10.2804 62.1838 10.3377C63.288 10.6732 64.4358 10.8431 65.5898 10.842C66.3248 10.8419 67.0581 10.7729 67.7803 10.636C68.307 10.5366 68.8065 10.326 69.2455 10.0184L69.2471 10.0174C69.2903 9.987 69.3418 9.9706 69.3947 9.97046C69.4475 9.97032 69.4992 9.98645 69.5426 10.0167C69.9824 10.3242 70.4822 10.5352 71.0094 10.636C71.7315 10.773 72.4649 10.8419 73.2 10.8418C74.3629 10.8418 75.5043 10.6727 76.6062 10.3377C76.7962 10.2805 76.9995 10.2846 77.187 10.3496C77.3745 10.4147 77.5366 10.5372 77.6504 10.6999L78.2978 11.6229C78.5353 11.9616 78.5279 12.4178 78.2719 12.7428C77.5675 13.6368 77.1133 14.7018 76.9557 15.8289C76.7981 16.956 76.9427 18.1048 77.3748 19.1577L78.4883 21.8778C79.0924 23.3532 78.9295 24.9585 78.0412 26.2821C77.1529 27.6057 75.7291 28.3647 74.1349 28.3647H73.2689C72.3566 28.3647 71.4222 28.5932 70.4918 29.0436C70.2822 29.1458 70.0768 29.2565 69.8762 29.3754Z",
    fill: "url(#paint14_linear_5470_30028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3947 9.97021C69.3418 9.97051 69.2902 9.98693 69.2469 10.0173L69.2453 10.0183C68.8063 10.3258 68.3068 10.5363 67.7801 10.6358C67.058 10.7727 66.3246 10.8417 65.5896 10.8419C64.4356 10.8431 63.2878 10.6731 62.1836 10.3376C61.9936 10.2803 61.7903 10.2845 61.6028 10.3495C61.4154 10.4145 61.2532 10.5371 61.1394 10.6997L60.4875 11.6292C60.2488 11.9694 60.2672 12.4235 60.5236 12.7505C61.4126 13.8833 61.8954 15.2818 61.8949 16.7218C61.8956 17.5572 61.7325 18.3847 61.415 19.1575L60.3012 21.8778C59.7756 23.1616 59.8309 24.5438 60.4394 25.7534C61.2519 27.3681 62.9291 28.3649 64.7367 28.3649H65.5209C66.6322 28.3649 67.79 28.7118 68.9139 29.3759C69.0594 29.462 69.2256 29.5074 69.3947 29.5071V9.97021Z",
    fill: "url(#paint15_linear_5470_30028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6502 10.7001C77.5365 10.5374 77.3743 10.4149 77.1868 10.3498C76.9993 10.2848 76.796 10.2807 76.6061 10.338C75.5018 10.6734 74.3539 10.8433 73.1998 10.8421C72.465 10.8421 71.7279 10.7728 71.0092 10.6362C70.4821 10.5355 69.9822 10.3244 69.5424 10.0169C69.499 9.98669 69.4474 9.97056 69.3945 9.9707C69.3416 9.97084 69.2901 9.98724 69.2469 10.0177L69.2453 10.0187C68.8063 10.3262 68.3068 10.5367 67.7801 10.6362C67.058 10.7731 66.3246 10.8421 65.5896 10.8423C64.4356 10.8435 63.2878 10.6735 62.1836 10.338C61.9936 10.2807 61.7903 10.2849 61.6029 10.3499C61.4154 10.4149 61.2532 10.5375 61.1395 10.7001L60.4875 11.6296C60.2488 11.9698 60.2672 12.4239 60.5236 12.7509C61.4126 13.8837 61.8954 15.2822 61.8949 16.7222C61.8956 17.4565 61.7696 18.1854 61.5225 18.8769H77.2678C76.9024 17.853 76.8029 16.7533 76.9784 15.6805C77.154 14.6077 77.5989 13.597 78.2715 12.7431C78.5275 12.4181 78.535 11.9618 78.2975 11.6231L77.6502 10.7001Z",
    fill: "url(#paint16_linear_5470_30028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1482 16.7827L70.0201 13.6545V19.8893L64.1152 22.7438L70.442 29.0706C70.4586 29.0624 70.475 29.052 70.4916 29.0438C71.4221 28.5932 72.3564 28.3649 73.2687 28.3649H74.1348C75.7289 28.3649 77.1525 27.6057 78.041 26.2823C78.9293 24.9586 79.0924 23.3534 78.4881 21.878L77.3746 19.1579C77.3699 19.1463 77.3664 19.1344 77.3617 19.1229L74.7086 16.4698L73.1482 16.7827Z",
    fill: "url(#paint17_linear_5470_30028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0049 15.6451L68.8445 13.8244C69.102 13.2662 69.9 13.2795 70.1385 13.8461L70.9164 15.6939C71.0138 15.9254 71.1824 16.1198 71.3978 16.249C71.6131 16.3782 71.864 16.4355 72.1141 16.4125L74.1107 16.2293C74.7228 16.173 75.1103 16.8709 74.7389 17.3609L73.5275 18.9586C73.3758 19.1587 73.2917 19.402 73.2875 19.6531C73.2833 19.9042 73.3592 20.1501 73.5041 20.3553L74.6609 21.9928C75.0156 22.4949 74.6051 23.1793 73.9951 23.1025L72.0059 22.8523C71.7567 22.821 71.504 22.8698 71.2844 22.9917C71.0648 23.1136 70.8898 23.3022 70.7846 23.5303L69.9449 25.351C69.6875 25.9092 68.8895 25.8959 68.651 25.3293L67.873 23.4814C67.7756 23.25 67.607 23.0555 67.3917 22.9263C67.1763 22.7971 66.9255 22.7399 66.6754 22.7629L64.6787 22.9461C64.0666 23.0023 63.6791 22.3045 64.0506 21.8144L65.2619 20.2168C65.4136 20.0166 65.4977 19.7734 65.5019 19.5223C65.5061 19.2712 65.4303 19.0252 65.2853 18.8201L64.1285 17.1826C63.7738 16.6804 64.1844 15.9961 64.7943 16.0728L66.7836 16.323C67.0328 16.3544 67.2855 16.3056 67.505 16.1837C67.7246 16.0618 67.8997 15.8731 68.0049 15.6451Z",
    fill: "url(#paint18_linear_5470_30028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0059 22.8522L73.9951 23.1024C74.1109 23.1181 74.2288 23.1042 74.3379 23.0621C74.4469 23.02 74.5435 22.9511 74.6187 22.8616L64.052 16.5063C64.0056 16.6161 63.9883 16.736 64.0017 16.8545C64.0151 16.9729 64.0588 17.0859 64.1285 17.1825L65.2853 18.82C65.4303 19.0251 65.5061 19.2711 65.5019 19.5222C65.4977 19.7733 65.4136 20.0166 65.2619 20.2167L64.0506 21.8144C63.6791 22.3042 64.0666 23.0021 64.6787 22.946L66.6754 22.7628C66.9255 22.7398 67.1764 22.7971 67.3917 22.9263C67.6071 23.0556 67.7757 23.25 67.873 23.4815L68.651 25.3294C68.8895 25.896 69.6875 25.9095 69.9449 25.3511L70.7846 23.5304C70.8897 23.3023 71.0648 23.1136 71.2844 22.9917C71.504 22.8698 71.7567 22.8209 72.0059 22.8522Z",
    fill: "url(#paint19_linear_5470_30028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2266 22.8284C64.3521 22.9124 64.5045 22.962 64.6789 22.9459L66.6756 22.7627C66.9257 22.7398 67.1765 22.797 67.3919 22.9262C67.6072 23.0554 67.7758 23.2498 67.8732 23.4813L68.6512 25.3291C68.8896 25.8958 69.6877 25.9092 69.9451 25.351L70.7848 23.5303C70.89 23.3023 71.065 23.1136 71.2846 22.9917C71.5042 22.8699 71.7569 22.821 72.0061 22.8524L73.9953 23.1026C74.6053 23.1793 75.016 22.495 74.6611 21.9928L73.5041 20.3553C73.3592 20.1502 73.2834 19.9043 73.2876 19.6532C73.2918 19.402 73.3758 19.1588 73.5275 18.9586L74.7389 17.361C74.9486 17.0842 74.9109 16.7452 74.7328 16.509L64.2266 22.8284Z",
    fill: "url(#paint20_linear_5470_30028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.739 17.3611C75.1105 16.8712 74.723 16.1734 74.1109 16.2294L72.1142 16.4126C71.8642 16.4356 71.6133 16.3784 71.3979 16.2492C71.1826 16.12 71.014 15.9255 70.9166 15.6941L70.1386 13.8462C70.0035 13.5253 69.689 13.3822 69.3949 13.4197V25.756C69.5137 25.7417 69.6269 25.6969 69.7233 25.6259C69.8197 25.555 69.8961 25.4603 69.9451 25.3511L70.7847 23.5304C70.8899 23.3023 71.065 23.1137 71.2846 22.9918C71.5042 22.8699 71.7568 22.8211 72.006 22.8525L73.9953 23.1027C74.6052 23.1794 75.016 22.495 74.6611 21.9929L73.5043 20.3554C73.3593 20.1503 73.2835 19.9043 73.2877 19.6532C73.2919 19.4021 73.376 19.1589 73.5277 18.9587L74.739 17.3611Z",
    fill: "url(#paint21_linear_5470_30028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0199 41.5132H46.7697C45.9605 41.5132 45.3049 42.169 45.3049 42.978C45.3049 43.787 45.9605 44.4429 46.7697 44.4429H92.0199C92.8291 44.4429 93.4848 43.787 93.4848 42.978C93.4848 42.169 92.8291 41.5132 92.0199 41.5132Z",
    fill: "url(#paint22_linear_5470_30028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2592 50.5884H46.7697C45.9605 50.5884 45.3049 51.2442 45.3049 52.0532C45.3049 52.8622 45.9605 53.5181 46.7697 53.5181H70.2592C70.6477 53.5181 71.0203 53.3637 71.295 53.089C71.5697 52.8143 71.724 52.4417 71.724 52.0532C71.724 51.6647 71.5697 51.2921 71.295 51.0174C71.0203 50.7427 70.6477 50.5884 70.2592 50.5884Z",
    fill: "url(#paint23_linear_5470_30028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0199 62.0308H46.7697C45.9605 62.0308 45.3049 62.6866 45.3049 63.4956C45.3049 64.3046 45.9605 64.9604 46.7697 64.9604H92.0199C92.8291 64.9604 93.4848 64.3046 93.4848 63.4956C93.4848 62.6866 92.8291 62.0308 92.0199 62.0308Z",
    fill: "url(#paint24_linear_5470_30028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8523 71.106H46.7697C45.9605 71.106 45.3049 71.7618 45.3049 72.5708C45.3049 73.3798 45.9605 74.0356 46.7697 74.0356H75.8523C76.2408 74.0356 76.6134 73.8813 76.8881 73.6066C77.1628 73.3319 77.3172 72.9593 77.3172 72.5708C77.3172 72.1823 77.1628 71.8097 76.8881 71.535C76.6134 71.2603 76.2408 71.106 75.8523 71.106Z",
    fill: "url(#paint25_linear_5470_30028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6812 42.8296C23.3158 39.9583 20.8726 37.8064 17.9781 37.8064H5.74999C2.2867 37.8064 -0.390444 40.8458 0.0468606 44.2816L6.4994 94.9767C6.86503 97.848 9.30819 100 12.2027 100H79.0017C82.465 100 85.1422 96.9605 84.7049 93.5248L79.531 52.8761C79.1656 50.0048 76.7225 47.8529 73.8279 47.8529H29.3846C26.4898 47.8531 24.0467 45.7011 23.6812 42.8296Z",
    fill: "url(#paint26_linear_5470_30028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.49941 94.9768C6.86503 97.8481 9.3082 100 12.2027 100H79.0018C82.465 100 85.1422 96.9606 84.7049 93.5249L83.7561 86.0696H5.36581L6.49941 94.9768Z",
    fill: "url(#paint27_linear_5470_30028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2082 10.9187C47.7038 10.8244 48.1738 10.6261 48.5871 10.3369C49.0012 10.048 49.3511 9.67663 49.6149 9.24609C49.6914 9.12031 49.7991 9.01645 49.9276 8.94462C50.0561 8.87278 50.201 8.83541 50.3483 8.83613C50.6426 8.83613 50.9377 8.98418 51.1027 9.28105C51.5826 10.1436 52.4656 10.7203 53.4346 10.9084C53.9537 11.0092 54.4766 11.0814 55.0008 11.1307C55.0349 11.1336 55.0692 11.1295 55.1016 11.1185C55.134 11.1075 55.1637 11.0899 55.1889 11.0667C55.2141 11.0436 55.2343 11.0155 55.248 10.9841C55.2617 10.9528 55.2688 10.919 55.2688 10.8848V1.22617C55.2688 1.06515 55.237 0.905702 55.1754 0.756936C55.1138 0.60817 55.0235 0.472998 54.9096 0.359137C54.7958 0.245277 54.6606 0.154958 54.5118 0.0933368C54.3631 0.0317159 54.2036 0 54.0426 0L46.6547 0C46.3295 0 46.0176 0.129186 45.7877 0.359137C45.5577 0.589089 45.4285 0.900971 45.4285 1.22617V10.9678C45.4285 11.0028 45.4362 11.0374 45.4512 11.0692C45.4661 11.1009 45.4878 11.1289 45.5148 11.1513C45.5418 11.1737 45.5734 11.1898 45.6073 11.1986C45.6412 11.2073 45.6767 11.2085 45.7111 11.202L47.2082 10.9187Z",
    fill: "url(#paint28_linear_5470_30028)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5470_30028",
    x1: 35.4588,
    y1: 23.3757,
    x2: 46.11,
    y2: 47.6022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5470_30028",
    x1: 30.285,
    y1: 49.7673,
    x2: 39.9814,
    y2: 49.7673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    stopColor: "#FDA116",
    stopOpacity: 0.177
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#FA921D",
    stopOpacity: 0.394
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#F4792A",
    stopOpacity: 0.633
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#ED573B",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5470_30028",
    x1: 52.4956,
    y1: 82.5741,
    x2: 21.0788,
    y2: 24.4475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#0653F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#D8DAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5470_30028",
    x1: 51.584,
    y1: 34.635,
    x2: 103.833,
    y2: 75.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADB9EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5470_30028",
    x1: 59.1109,
    y1: 13.7603,
    x2: 47.1877,
    y2: 6.83359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADB9EB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259,
    stopColor: "#AAB5E7",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#A0A7DA",
    stopOpacity: 0.542
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834,
    stopColor: "#8F92C6",
    stopOpacity: 0.834
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8382B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5470_30028",
    x1: 90.8607,
    y1: 43.0348,
    x2: 100.767,
    y2: 43.0348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADB9EB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259,
    stopColor: "#AAB5E7",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#A0A7DA",
    stopOpacity: 0.542
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834,
    stopColor: "#8F92C6",
    stopOpacity: 0.834
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8382B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5470_30028",
    x1: 88.773,
    y1: 37.9958,
    x2: 61.7693,
    y2: 15.8793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADB9EB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259,
    stopColor: "#AAB5E7",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#A0A7DA",
    stopOpacity: 0.542
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834,
    stopColor: "#8F92C6",
    stopOpacity: 0.834
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8382B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5470_30028",
    x1: 94.1457,
    y1: 25.9598,
    x2: 91.5092,
    y2: 9.18262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADB9EB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259,
    stopColor: "#AAB5E7",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#A0A7DA",
    stopOpacity: 0.542
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834,
    stopColor: "#8F92C6",
    stopOpacity: 0.834
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8382B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5470_30028",
    x1: 89.3326,
    y1: 8.21875,
    x2: 93.2871,
    y2: 17.2066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADB9EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5470_30028",
    x1: 69.3949,
    y1: 79.4702,
    x2: 69.3949,
    y2: 86.8751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADB9EB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259,
    stopColor: "#AAB5E7",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#A0A7DA",
    stopOpacity: 0.542
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834,
    stopColor: "#8F92C6",
    stopOpacity: 0.834
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8382B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5470_30028",
    x1: 93.2201,
    y1: 66.971,
    x2: 80.5756,
    y2: 69.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADB9EB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259,
    stopColor: "#AAB5E7",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#A0A7DA",
    stopOpacity: 0.542
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834,
    stopColor: "#8F92C6",
    stopOpacity: 0.834
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8382B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5470_30028",
    x1: 62.6105,
    y1: 11.6593,
    x2: 77.392,
    y2: 26.4409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5470_30028",
    x1: 81.5289,
    y1: 30.6591,
    x2: 55.2492,
    y2: 4.37965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5470_30028",
    x1: 69.3947,
    y1: 29.4317,
    x2: 69.3947,
    y2: 33.7506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    stopColor: "#FDA116",
    stopOpacity: 0.177
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#FA921D",
    stopOpacity: 0.394
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#F4792A",
    stopOpacity: 0.633
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#ED573B",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_5470_30028",
    x1: 51.5412,
    y1: 0.879347,
    x2: 85.1168,
    y2: 34.4549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    stopColor: "#FDA116",
    stopOpacity: 0.177
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#FA921D",
    stopOpacity: 0.394
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#F4792A",
    stopOpacity: 0.633
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#ED573B",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_5470_30028",
    x1: 64.8434,
    y1: 19.5265,
    x2: 59.5553,
    y2: 19.2794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    stopColor: "#FDA116",
    stopOpacity: 0.177
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#FA921D",
    stopOpacity: 0.394
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#F4792A",
    stopOpacity: 0.633
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#ED573B",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_5470_30028",
    x1: 69.3945,
    y1: 14.5278,
    x2: 69.3945,
    y2: 9.47158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    stopColor: "#FDA116",
    stopOpacity: 0.177
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#FA921D",
    stopOpacity: 0.394
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#F4792A",
    stopOpacity: 0.633
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#ED573B",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_5470_30028",
    x1: 78.149,
    y1: 27.584,
    x2: 63.9699,
    y2: 15.3383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    stopColor: "#FDA116",
    stopOpacity: 0.177
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#FA921D",
    stopOpacity: 0.394
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#F4792A",
    stopOpacity: 0.633
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#ED573B",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_5470_30028",
    x1: 67.142,
    y1: 17.3347,
    x2: 72.3072,
    y2: 22.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_5470_30028",
    x1: 68.3355,
    y1: 20.9165,
    x2: 70.85,
    y2: 17.8173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    stopColor: "#FDA116",
    stopOpacity: 0.177
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#FA921D",
    stopOpacity: 0.394
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#F4792A",
    stopOpacity: 0.633
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#ED573B",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_5470_30028",
    x1: 70.2049,
    y1: 21.4127,
    x2: 68.4945,
    y2: 17.2215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    stopColor: "#FDA116",
    stopOpacity: 0.177
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#FA921D",
    stopOpacity: 0.394
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#F4792A",
    stopOpacity: 0.633
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#ED573B",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_5470_30028",
    x1: 72.458,
    y1: 18.8419,
    x2: 64.7974,
    y2: 20.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    stopColor: "#FDA116",
    stopOpacity: 0.177
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#FA921D",
    stopOpacity: 0.394
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#F4792A",
    stopOpacity: 0.633
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#ED573B",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_5470_30028",
    x1: 54.4996,
    y1: 18.8274,
    x2: 78.5467,
    y2: 57.8163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1B4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_5470_30028",
    x1: 39.7691,
    y1: 21.6604,
    x2: 66.8117,
    y2: 65.5062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1B4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_5470_30028",
    x1: 54.4996,
    y1: 39.345,
    x2: 78.5467,
    y2: 78.3341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1B4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_5470_30028",
    x1: 38.9592,
    y1: 36.3304,
    x2: 71.2047,
    y2: 88.6118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1B4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_5470_30028",
    x1: 48.2506,
    y1: 108.031,
    x2: 8.84865,
    y2: 41.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#6796FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#D8DAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_5470_30028",
    x1: 45.0588,
    y1: 94.9154,
    x2: 45.0588,
    y2: 102.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D256A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#4D256A",
    stopOpacity: 0.204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#4044D2",
    stopOpacity: 0.337255
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#4D256A",
    stopOpacity: 0.773
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D256A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_5470_30028",
    x1: 47.0594,
    y1: 3.09395,
    x2: 53.8053,
    y2: 8.78184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F2D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5470_30028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFile);
export default __webpack_public_path__ + "static/media/emptyFile.d62f91d25a3e2e91c257b5cf397cb459.svg";
export { ForwardRef as ReactComponent };